import { useTranslation } from 'react-i18next';

import { StartRoute } from '@/features/start/navigation/startRoute';
import { CivilProtectionScreen } from '@/features/start/screens/CivilProtectionScreen';
import { StartScreen } from '@/features/start/screens/StartScreen';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { AppStack } from '@/navigation/stacks/appStack';

export const useStartRouting = () => {
  const { t } = useTranslation(LocalizationNameSpace.START, {
    keyPrefix: 'routes'
  });

  return {
    startScreens: [
      <AppStack.Screen
        key={StartRoute.Start}
        name={StartRoute.Start}
        component={StartScreen}
      />,
      <AppStack.Screen
        key={StartRoute.CivilProtection}
        name={StartRoute.CivilProtection}
        component={CivilProtectionScreen}
        options={({ route }) => ({
          title: t(StartRoute.CivilProtection, {
            count: route.params?.count ?? 0
          })
        })}
      />
    ]
  };
};
